export const generateCode = (name: string) => {
  return name
    .trim()
    .normalize()
    .replace(/[^\w-]+/g, "_")
    .toLowerCase();
};
